module.exports = __webpack_public_path__ + "img/sign.7866d276.jpeg";